export default function getClassLink(id) {
  return `/myClasses/singleClass/${id}`;
}
